import { DocsHeading } from "../../../../src/components/DocsHeading";
import { Input, PasswordInput, Textarea } from 'react-magma-dom';
import { Link } from 'gatsby';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  DocsHeading,
  Input,
  PasswordInput,
  Textarea,
  Link,
  LeadParagraph,
  React
};